import { Fragment, ReactNode } from "react";
import styles from "./RipperMessage.module.css";

interface RipperMessageProps {
  text: string;
  streaming?: boolean;
  showLabel?: boolean;
}

export function RipperMessage({ text, streaming, showLabel = true }: RipperMessageProps) {
  return (
    <div className={`${styles.row} ${showLabel ? "" : styles.rowContinuation}`}>
      {showLabel && (
        <div className={styles.label}>
          <span className={styles.labelGlyph} aria-hidden>
            ◇
          </span>
          <span className={styles.labelText}>ripper</span>
        </div>
      )}
      <div className={styles.bubble}>
        <span className={styles.text}>
          {renderWithHighlights(text)}
          {streaming && <span className={styles.cursor} aria-hidden>▍</span>}
        </span>
      </div>
    </div>
  );
}

/**
 * Highlights KPI-ish tokens (currency amounts, percentages, bps, Visa/mcc codes)
 * with bold accent styling so the eye lands on the numbers that matter.
 */
const KPI_REGEX =
  /([€£$]\s?\d(?:[\d,.]*)?\s?(?:[kmbn](?:n)?)?|\d+(?:\.\d{1,3})?\s?%|\d+\s?bps|mcc\s?\d{4})/gi;

function renderWithHighlights(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  let lastIdx = 0;
  let match;
  let key = 0;
  while ((match = KPI_REGEX.exec(text)) !== null) {
    if (match.index > lastIdx) {
      parts.push(
        <Fragment key={key++}>{text.slice(lastIdx, match.index)}</Fragment>
      );
    }
    parts.push(
      <strong key={key++} className={styles.kpi}>
        {match[0]}
      </strong>
    );
    lastIdx = match.index + match[0].length;
  }
  if (lastIdx < text.length) {
    parts.push(<Fragment key={key++}>{text.slice(lastIdx)}</Fragment>);
  }
  return parts.length > 0 ? parts : [text];
}
